<script setup lang="ts">
/**
 * Bloco de compliance reutilizável (ENG-404): advertência oficial rotativa,
 * aviso 18+ e identificação do operador — tudo em texto discreto (sem
 * tarja/pill), pois é elemento de ambiente/UI.
 *
 * Fonte de verdade única — usado no modal de login/register (via
 * AuthComplianceInfo), no preview de jogo mobile (MobilePreview) e na
 * página de jogo desktop.
 */
const { t } = useTexts();
</script>

<template>
  <div :class="$style.complianceInfo">
    <BaseComplianceWarningNotice :class="$style.warning" />

    <p :class="$style.legal">
      {{ t('compliance.age_restriction') }} -
      {{ t('compliance.identification') }}
    </p>
  </div>
</template>

<style module lang="scss">
.complianceInfo {
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  padding-top: 4px;
}

.warning {
  width: 100%;
}

.legal {
  margin: 0;
  text-align: center;
  /* Mesmo cinza legível do WarningNotice. */
  color: rgba(255, 255, 255, 0.6);
  font-family: 'Montserrat', sans-serif;
  font-size: 10px;
  line-height: 1.5;
}
</style>
